import { Component, Input } from '@angular/core';
import { ListedCar } from 'src/app/core/models/car.model';

@Component({
  selector: 'app-car-specs',
  templateUrl: './car-specs.component.html',
  styleUrls: ['./car-specs.component.scss',],
})
export class CarSpecsComponent {

  @Input() carDetails?: ListedCar;
  
  constructor() { }

}
